
import { AbstractControl, ValidatorFn, UntypedFormGroup, UntypedFormArray, UntypedFormControl } from '@angular/forms';

export function DateValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let isValid = (/^(\d{1,2}\/\d{1,2}\/(\d{2}|\d{4}))|(\d{4}-\d{2}-\d{2})$/.test(control.value));
    if (isValid) {
      const dateObject = new Date(control.value);
      if (isNaN(dateObject.getTime())) {
        isValid = false;
      } else if (dateObject.getFullYear() < 1753) {
        isValid = false;
      } else if (dateObject.getFullYear() > 2199) {
        isValid = false;
      }
    }

    return !isValid ? { invalidDate: { value: control.value } } : null;
  };
}

export function ValidatorRequiredIfBool(requiredControl: string, ifControl: string): ValidatorFn {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    if (!form || !form.get(ifControl).value) {
      return null;
    } else if (form.get(requiredControl).value === null || form.get(requiredControl).value === undefined) {
      form.get(requiredControl).setErrors({ required: { value: form.get(requiredControl).value } });
      return { required: { value: form.get(requiredControl).value } };
    }
  };
}

export function ValidatorRequiredNotEmptyIfBool(requiredControl: string, ifControl: string): ValidatorFn {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    if (!form || !form.get(ifControl).value) {
      return null;
    } else if (form.get(requiredControl).value === null || form.get(requiredControl).value === undefined || form.get(requiredControl).value === "") {
      form.get(requiredControl).setErrors({ required: { value: form.get(requiredControl).value } });
      return { required: { value: form.get(requiredControl).value } };
    }
  };
}


export function ValidatorRequiredNotEmptyIfFalse(requiredControl: string, ifControl: string): ValidatorFn {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    if (!form || form.get(ifControl).value == null || form.get(ifControl).value == undefined || form.get(ifControl).value == true) {
      return null;
    } else if (form.get(requiredControl).value === null || form.get(requiredControl).value === undefined || form.get(requiredControl).value === "") {
      form.get(requiredControl).setErrors({ required: { value: form.get(requiredControl).value } });
      return { required: { value: form.get(requiredControl).value } };
    }
  };
}


export function ValidatorRequiredTrueIfBool(requiredControl: string, ifControl: string): ValidatorFn {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    if (!form || !form.get(ifControl).value) {
      return null;
    } else if (!form.get(requiredControl).value) {
      form.get(requiredControl).setErrors({ required: { value: form.get(requiredControl).value } });
      return { required: { value: form.get(requiredControl).value } };
    }
  };
}

export function ValidatorConfirmField(confirmControl: string, originalControl: string): ValidatorFn {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    if (!form || !form.get(originalControl) || !form.get(confirmControl)) {
      return null;
    } else if (form.get(originalControl).value !== form.get(confirmControl).value) {
      form.get(confirmControl).setErrors({ confirmNotEqual: { value: form.get(confirmControl).value } });
      return { confirmNotEqual: { value: form.get(confirmControl).value } };
    }
  };
}


export function ValidatorRequiredIfOtherFieldNotEquals(requiredControls: string[], ifControl: string, notEqualsTo: any): ValidatorFn {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    if (!form || !form.get(ifControl) || form.get(ifControl).value === notEqualsTo) {
      for (const requiredControl of requiredControls) {
          form.get(requiredControl).setErrors(null);
      }
      return null;
    } else {
      let anyError = false;
      for (const requiredControl of requiredControls) {
        if (form.get(requiredControl).value === '' || form.get(requiredControl).value === null || form.get(requiredControl).value === undefined) {
          form.get(requiredControl).setErrors({ required: { value: form.get(requiredControl).value } });
          anyError = true;
        } else {
          form.get(requiredControl).setErrors(null);
        }
      }
      return anyError ? { required: { value: form.get(requiredControls[0]).value } } : null;
    }
  };
}

export function ValidatorRequiredArrayNotEmptyOrTrue(requiredArray: string, notEmptyArrayControls :string[], ifEmptyRequiredTrueControl): ValidatorFn {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {

    if (!form || !form.get(requiredArray) || !form.get(ifEmptyRequiredTrueControl)) {
      return null;
    }       

    {
      if (form.get(ifEmptyRequiredTrueControl).value) {
        form.get(ifEmptyRequiredTrueControl).setErrors(null);
        form.get(requiredArray).setErrors(null);
        return null;
      }
       
      let formArray = form.get(requiredArray) as UntypedFormArray;
      if (formArray === null || formArray.length === 0) {
        form.get(requiredArray).setErrors(null);
        form.get(ifEmptyRequiredTrueControl).setErrors({ required: { value: form.get(ifEmptyRequiredTrueControl).value } });
        return { required: { value: form.get(ifEmptyRequiredTrueControl).value } };
      }

      form.get(ifEmptyRequiredTrueControl).setErrors(null);

      let hasValue = false;
      for (const arrayGroup of formArray.controls) {
        let g = arrayGroup as UntypedFormGroup;        
        for (const controlName of notEmptyArrayControls) {
          let controlValue = g.get(controlName) as UntypedFormControl;
          if (controlValue != null && controlValue.value !== null && (controlValue.value > 0 || (typeof controlValue.value === 'string' && controlValue.value.trim().length > 1))) {
            hasValue = true;
            break;
          }
        }        
        
      }

      if (hasValue) {
        form.get(requiredArray).setErrors(null);
        return null;
      }

      form.get(requiredArray).setErrors({ required: { value: form.get(requiredArray).value } });
      return { required: { value: form.get(requiredArray).value } };
    }
  };
}
